import React, { FC, useCallback } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import Person from '@mui/icons-material/Person'
import Error from '@mui/icons-material/Error'
import CalendarToday from '@mui/icons-material/CalendarToday'
import WatchLater from '@mui/icons-material/WatchLater'
import BaseModal from 'components/BaseModal'
import CoreButton from 'components/Core/CoreButton'
import { Calendar, Event } from './types'

dayjs.extend(utc)
dayjs.extend(timezone)

interface RescheduleWarningModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  calendar: Calendar
  event: Event
  onConfirm: () => void
}

const RescheduleWarningModal: FC<RescheduleWarningModalProps> = ({ open, setOpen, calendar, event, onConfirm }) => {
  const handleClose = useCallback(() => {
    setOpen(false)
  }, [setOpen])

  return (
    <BaseModal open={open} setOpen={setOpen} className="tw:!p-0 tw:!rounded-4xl">
      <div className="tw:bg-yellow-100 tw:flex tw:items-center tw:justify-center tw:py-12">
        <Error className="tw:!size-16 tw:text-yellow-600" />
      </div>
      <div className="tw:p-6 tw:flex tw:flex-col">
        <h2 className="tw:text-lg tw:font-bold">{'Are you sure you want to reschedule?'}</h2>
        <p className="tw:text-secondary-black">
          {'Reschedulings may result in the project being reassigned to another vendor'}
        </p>
        <div className="tw:flex tw:gap-4 tw:items-center tw:text-sm tw:font-semibold tw:py-2 tw:mt-4">
          <div className="tw:size-8 tw:bg-neutrals-200 tw:shrink-0 tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <Person className="tw:!size-5" />
          </div>
          <div className="tw:grow">{calendar.property.full_name}</div>
        </div>
        <div className="tw:w-full">
          <div className="tw:flex tw:items-center tw:gap-4 tw:my-3">
            <div className="tw:bg-neutrals-200 tw:p-1.5 tw:rounded-full tw:flex tw:items-center tw:justify-center">
              <CalendarToday className="tw:!size-5" />
            </div>
            <div className="tw:grow tw:font-medium">
              {dayjs(event.start_time).tz(calendar.property.time_zone).format('ddd, D MMM')}
            </div>
          </div>
          <div className="tw:flex tw:items-center tw:gap-4 tw:my-3">
            <div className="tw:bg-neutrals-200 tw:p-1.5 tw:rounded-full tw:flex tw:items-center tw:justify-center">
              <WatchLater className="tw:!size-5" />
            </div>
            <div className="tw:grow">
              <div>
                {dayjs(event.start_time).tz(calendar.property.time_zone).format('h:mm')}
                {' - '}
                {dayjs(event.end_time).tz(calendar.property.time_zone).format('h:mm A')}
              </div>
              <div className="tw:text-tertiary-black">{'Pacific Time'}</div>
            </div>
          </div>
        </div>
        <CoreButton type="button" size="l" kind="primary" text="Reschedule" onClick={onConfirm} className="tw:mt-6" />
        <CoreButton type="button" size="l" kind="secondary" text="Cancel" onClick={handleClose} className="tw:mt-3" />
      </div>
    </BaseModal>
  )
}

export default RescheduleWarningModal
